const MAIN_TAB_PATHS = new Set([
  '/friends',
  '/home',
  '/notifications',
  '/profile',
]);

export function shouldShowHeaderBackButton(pathname: string) {
  const normalizedPathname =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;

  return !MAIN_TAB_PATHS.has(normalizedPathname);
}

export function getHeaderBackFallbackPath(pathname: string) {
  const normalizedPathname =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;
  const garageMatch = normalizedPathname.match(/^\/garage\/([^/]+)\/[^/]+$/);

  if (garageMatch?.[1]) {
    return `/profile/${encodeURIComponent(garageMatch[1])}?tab=garage`;
  }

  return '/home';
}

export function shouldUseHeaderBackFallback(pathname: string) {
  const normalizedPathname =
    pathname.length > 1 && pathname.endsWith('/')
      ? pathname.slice(0, -1)
      : pathname;

  return /^\/garage\/[^/]+\/[^/]+$/.test(normalizedPathname);
}
